import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import { PlanCard } from "@/components/PlanCard";
import { Skeleton } from "@/components/ui/skeleton";

export default function Browse() {
  const { user } = useAuth();
  const [plans, setPlans] = useState(null);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    api
      .get("/plans")
      .then((r) => setPlans(r.data))
      .catch(() => {
        setPlans([]);
        toast.error("Could not load plans");
      });
  }, []);

  const join = async (planId) => {
    setBusyId(planId);
    try {
      await api.post(`/plans/${planId}/join`);
      toast.success("Request sent — the Planner will review it");
      setPlans((ps) =>
        ps.map((p) =>
          p.plan_id === planId
            ? { ...p, my_request_status: "pending", request_count: (p.request_count || 0) + 1 }
            : p
        )
      );
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send request");
    } finally {
      setBusyId(null);
    }
  };

  return (
    <AppShell>
      <div data-testid="browse-page">
        <h1 className="font-serif text-3xl font-bold tracking-tight text-white mb-1">Open Tables</h1>
        <p className="text-sm text-[#A0A0A0] mb-8">Sponsored meals waiting for a guest of honour.</p>

        {plans === null ? (
          <div className="space-y-5">
            {[0, 1, 2].map((i) => (
              <Skeleton key={i} className="h-56 w-full rounded-xl bg-[#15151A]" />
            ))}
          </div>
        ) : plans.length === 0 ? (
          <div className="text-center py-20 border border-dashed border-[#D4AF37]/25 rounded-xl" data-testid="browse-empty-state">
            <p className="font-serif text-xl text-white mb-2">The circle is quiet tonight</p>
            <p className="text-sm text-[#A0A0A0]">Be the first to sponsor a table.</p>
          </div>
        ) : (
          <div className="space-y-5" data-testid="plans-list">
            {plans.map((plan, i) => (
              <PlanCard
                key={plan.plan_id}
                plan={plan}
                index={i}
                currentUserId={user?.user_id}
                onJoin={join}
                busy={busyId === plan.plan_id}
              />
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
